import { type ContentTextComponent, type RootContainerProps } from "@client/content/types";
import { labelsSelector } from "@client/selectors";
import { I18nContextProvider } from "@common/contexts/I18n";
import { type WithChildren } from "@common/declarations";
import { EMPTY_OBJECT } from "@common/lib/misc";
import * as React from "react";
import { useSelector } from "react-redux";
import { type ContainerProps } from "./Containers/container";
import { getModuleData } from "./dataProvider";
import useReducers from "./hooks/useReducers";
import { getLabels } from "./lib/labels";

import "./styles/index.less";

type I18nContainerProps = WithChildren & {
  moduleType: string;
};
const I18nContainer = (props: I18nContainerProps) => {
  const labels = useSelector(labelsSelector);

  const i18n = React.useMemo(() => getLabels(labels, props.moduleType) ?? EMPTY_OBJECT, [labels, props.moduleType]);
  return <I18nContextProvider i18n={i18n}>{props.children}</I18nContextProvider>;
};

export type MapProps = ContainerProps & {
  moduleType: string;
  TextComponent: ContentTextComponent;
  StaticContainer: React.ComponentType<RootContainerProps>;
};

const ContentComponentInner = ({ moduleType, ...props }: MapProps) => {
  const Container = React.useMemo(
    (): React.ComponentType<RootContainerProps> | undefined => getModuleData(moduleType)?.Container,
    [moduleType]
  );

  if (!Container) return null;

  return (
    <I18nContainer moduleType={moduleType}>
      <Container {...props} />
    </I18nContainer>
  );
};

export default (props: MapProps) => {
  useReducers(props.moduleType, props.id);

  return <ContentComponentInner {...props} />;
};
